import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const titleSlice = createSlice({
  name: 'title',
  initialState,
  reducers: {},
});

export const titleReducer = titleSlice.reducer;
